/**
 * Represents the map in the liquidLayout
 * @constructor
 * @param {jQuery} jMapContainer  the container for the map
 * @param {object} oConfig        the configuration options
 */
define([
   'bing',
   'c21',
   'c21/maps',
   'c21/ajax',
   'c21/lazy',
   'c21/cookie',
   'c21/results',
   'c21/Params',
   'jquery',
   'c21/track',

   // TODO: Load libs as needed
   'c21/maps/PinData',
   'c21/maps/LassoTool',
   'c21/maps/BackgroundPropertyTooltipManager',
   'c21/maps/ResultPropertyTooltipManager',
   'c21/maps/OfficeTooltipManager',
   'c21/maps/AgentTooltipManager',
   'c21/maps/MyPlaceTooltipManager',
   'c21/maps/HeatMapLayer',
   'c21/maps/HeatMapAjax',
   'c21/maps/LocationBoundaryMapLayer',
   'c21/maps/LocationBoundaryMapAjax',
   'c21/maps/ZoomErrorMessage',
   'c21/maps/POIMapLayer',
   'c21/maps/ResultPropertyPinLayer',
   'c21/maps/BackgroundPropertyPinLayer',
   'c21/maps/PropertyPinAjax',
   'c21/maps/OfficePinLayer',
   'c21/maps/AgentPinLayer',
   'c21/maps/AreaOverlayUi',
   'c21/maps/MapTypeOverlay',
   'c21/maps/SchoolPinLayer',
   'c21/maps/SchoolTooltipManager',

   'c21/maps/SurroundingAreaTooltipManager',
   'c21/maps/SurroundingAreaMapLayer',

   'jqueryuniform'
], function (
   BingMaps,
   c21,
   C21Maps,
   ajax,
   lazy,
   cookie,
   results,
   Params,
   $,
   track,
   PinData,
   LassoTool,
   BackgroundPropertyTooltipManager,
   ResultPropertyTooltipManager,
   OfficeTooltipManager,
   AgentTooltipManager,
   MyPlaceTooltipManager,
   HeatMapLayer,
   HeatMapAjax,
   LocationBoundaryMapLayer,
   LocationBoundaryMapAjax,
   ZoomErrorMessage,
   POIMapLayer,
   ResultPropertyPinLayer,
   BackgroundPropertyPinLayer,
   PropertyPinAjax,
   OfficePinLayer,
   AgentPinLayer,
   AreaOverlayUi,
   MapTypeOverlay,
   SchoolPinLayer,
   SchoolTooltipManager,
   SurroundingAreaTooltipManager,
   SurroundingAreaMapLayer
) {
   "use strict";

   return function (jMapContainer, oConfig) {
      var self = this,

         m_bFirstUpdate = true,
         m_lassoLayer = new BingMaps.Layer(),
         m_lassoPoly = null,
         m_pinsFirstMapBounds,
         m_shapeFirstMapBounds,

         m_aLocationForUrl = [],
         m_mapZoomOnPageLoad = null,
         m_mapBoundaryOnPageLoad = null,

         m_elBingMap = jMapContainer.get(0),

         m_oConfig = $.extend({
            // Default data
            lockAutoZoomToPins: false
         }, oConfig || {}),

         m_bLockAutoZoom = m_oConfig.lockAutoZoomToPins,

         m_map = new BingMaps.Map(m_elBingMap, {
            credentials: C21Maps.bingmapCredentials,
            bounds: m_oConfig.bounds,

            center: (m_oConfig.center && m_oConfig.center.latitude) ? m_oConfig.center : undefined,
            zoom: m_oConfig.zoom,
            customizeOverlays: true,
            showMapTypeSelector: false,
            enableSearchLogo: false
         }),

         // Tooltip Managers
         m_backgroundPropertyTooltipManager,
         m_resultPropertyTooltipManager = new ResultPropertyTooltipManager(m_map),
         m_officeTooltipManager = new OfficeTooltipManager(m_map),
         m_agentTooltipManager = new AgentTooltipManager(m_map),
         m_myPlaceTooltipManager = new MyPlaceTooltipManager(m_map),
         m_schoolTooltipManager = new SchoolTooltipManager(m_map),

         // Heatmap
         m_heatMapLayer = new HeatMapLayer(m_map, m_lassoLayer),
         m_heatMapAjax = new HeatMapAjax(m_heatMapLayer),

         // Location boundaries
         m_locationBoundaryMapLayer = new LocationBoundaryMapLayer(m_map),
         m_locationBoundaryMapAjax = new LocationBoundaryMapAjax(m_locationBoundaryMapLayer),

         // Surrounding Areas
         m_surroundingAreaTooltipManager = new SurroundingAreaTooltipManager(m_map),
         m_surroundingAreaMapLayer,
         //= new SurroundingAreaMapLayer(m_map, this, m_surroundingAreaTooltipManager),      

         // Misc
         m_zoomErrorMessage = new ZoomErrorMessage(m_map),
         m_poiMapLayer = new POIMapLayer(m_map, m_zoomErrorMessage),
         //m_myPlacesMapLayer = new MyPlacesMapLayer(self, m_map, m_myPlaceTooltipManager),
         m_resultPropertyPinLayer = new ResultPropertyPinLayer(m_map, m_resultPropertyTooltipManager),
         m_backgroundPropertyPinLayer,
         m_propertyPinAjax,
         m_officeLayer = new OfficePinLayer(m_map, m_officeTooltipManager),
         m_agentLayer = new AgentPinLayer(m_map, m_agentTooltipManager),
         m_schoolPinLayer = new SchoolPinLayer(self, m_map, m_schoolTooltipManager),
         m_areaOverlayUi = new AreaOverlayUi(),
         m_mapTypeOverlay,
         //m_customMapHud = new CustomMapHud(m_map),
         m_lassoTool,
         m_pointsOfInterestFilter,
         m_jListContainer,

         /**
          * ==================
          * BEGIN CLEANUP TODO: FUNCTIONS THAT DO NOT BELONG IN MAP CLASS!!
          */

         /**
          * Disable & Deselect Search Within Map Checkbox
          */

         /* SEARCH WITHIN MAP CLASS */
         disableSearchWithinMap = function () {
            $('#searchWithinMap').prop("checked", false);
            $('#searchWithinMap').prop("disabled", true);
         },

         searchWithinMapEnabled = function () {
            return $('#searchWithinMap').prop("checked");
         },

         /* MY PLACES CLASS */
         m_bMyPlacesEnabled = false,
         enableMyPlaces = function () {
            m_bMyPlacesEnabled = true;
            track.doEvent('Hybrid Mapping', 'Tool Bar', 'Select My Places Tool');
            $("#saveSearchButton").css("display", "none");
            $("#myPlacesTool").addClass('selected');
            $("#mapToolTip").hide();

            // TODO: Fix places
            // Load the current list of my places from the server
            //places.getMyPlaces();
         },

         disableMyPlaces = function () {
            m_bMyPlacesEnabled = false;
            track.doEvent('Hybrid Mapping', 'Tool Bar', 'Deselect My Places Tool');
            $("#saveSearchButton").css("display", "inline");
            $("#myPlacesTool").removeClass('selected');
            $("#myPlacesToolInstructions").removeClass('active');
            self.clearMyC21Places();
         },

         isMyPlacesEnabled = function () {
            return m_bMyPlacesEnabled;
         },

         /*
         initializeMyPlacesToolInterface = function () {
            var jMyPlacesTool = $("#myPlacesTool");

            jMyPlacesTool.click(function () {
               if (jMyPlacesTool.hasClass('selected')) {
                  disableMyPlaces();
               } else {
                  enableMyPlaces();
               }
            });

            $("#myPlacesToolInstructions .addPlaceLink").click(function () {
               // TODO: Fix places
               //places.loadMyPlacesModal();
            });
         },
         */

         PointsOfInterestFilter = function (refreshPOI) {
            var self = this,
               m_jCheckboxes,

               initialize = function () {
                  m_jCheckboxes = $("#pointsOfInterestDiv .pointOfInterestCheckbox");

                  var strPoiInit = new Params().getParam("poi"),
                     aPoiInit = (strPoiInit) ? strPoiInit.split(",") : [];

                  m_jCheckboxes.change(function () {
                     // GA track point of interest only if its checked 
                     if ($(this).prop("checked")) {
                        track.doEvent('Hybrid Mapping', 'Points Of Interest Tool', 'Select ' + $(this).attr("id"));
                     } else {
                        track.doEvent('Hybrid Mapping', 'Points Of Interest Tool', 'Deselect ' + $(this).attr("id"));
                     }

                     refreshPOI();
                  }).each(function () {
                     var jCheck = $(this);
                     if ($.inArray(jCheck.val(), aPoiInit) >= 0) {
                        jCheck.prop("checked", true);
                     }
                  });

                  m_jCheckboxes.uniform();
               };

            self.getTypes = function () {
               var sTypes = '';

               m_jCheckboxes.each(function () {
                  if ($(this).prop("checked")) {
                     sTypes += ((sTypes.length > 0 ? ',' : '') + $(this).val());
                  }
               });

               return sTypes;
            };

            self.setHash = function (sStartTypes) {
               var sTypes = (sStartTypes === "") ? null : sStartTypes;
               ajax.setHash(ajax.getHash(), true, {
                  poi: sTypes
               });
            };

            initialize();
         },
         /**
          * END CLEANUP TODO: FUNCTIONS THAT DO NOT BELONG IN MAP CLASS!!
          * ==================
          */

         moveLassoPolyToTop = function () {
            if (!m_lassoPoly) {
               return;
            }
            m_lassoPoly.setOptions({
               visible: false
            });
            m_lassoPoly.setOptions({
               visible: true
            });
         },

         refreshHeatmap = function () {
            //var iZoom = m_map.getZoom(),
            //   iMinZoomLevel = 8,
            var strSelectedArea = m_areaOverlayUi.getAreaOverlaySelection();

            if (strSelectedArea) {
               if (m_zoomErrorMessage.inRange()) {
                  m_zoomErrorMessage.disable('heatmap');
                  var bounds = self.getBounds();
                  m_locationBoundaryMapLayer.clearLocationBoundaryMap();
                  m_heatMapAjax.getData(bounds, {
                     meta: strSelectedArea,
                     success: function () {
                        moveLassoPolyToTop();
                     },
                     error: function (jqXHR, textStatus, errorThrown) {
                        // We don't care about 'abort' errors, as those are purposeful
                        if (textStatus === 'abort') {
                           return;
                        }

                        // Disabled per AF
                        //alert('An error has occurred while loading the heatmap. The page needs reloaded');
                        //window.location.reload();
                     }
                  });
               } else {
                  m_zoomErrorMessage.enable('heatmap');
                  m_locationBoundaryMapLayer.clearLocationBoundaryMap();
               }
            } else {
               m_zoomErrorMessage.disable('heatmap');
               m_heatMapLayer.clearHeatMap();
               m_heatMapAjax.cancel();
               self.refreshLocationBoundaryMap();
            }
         },

         removeLassoPoly = function () {
            if (!m_lassoPoly) {
               return;
            }
            m_lassoLayer.remove(m_lassoPoly);
            m_lassoPoly = null;
         },

         deselectDrawingTool = function () {
            var jDrawTool = $("#drawTool"),
               jInstructions = $("#drawingToolInstructions");

            track.doEvent('Hybrid Mapping', 'Tool Bar', 'Deselect Drawing Tool');
            $("#saveSearchButton").css("display", "inline");
            //portalResults.removeLiquidMapDrawingToolFacet(null);
            removeLassoPoly();
            m_lassoTool.stop();
            jDrawTool.removeClass('selected');
            jInstructions.removeClass('active');
            self.refreshLocationBoundaryMap();
         },

         initializeDrawToolInterface = function () {
            var jDrawTool = $("#drawTool"),
               jInstructions = $("#drawingToolInstructions"),
               strEvent = c21.isTouchscreen() ? "touchend" : "click";

            jDrawTool.on(strEvent, function (e) {
               e.preventDefault();

               if (jDrawTool.hasClass('selected')) {
                  track.doEvent('Hybrid Mapping', 'Tool Bar', 'Deselect Drawing Tool');
                  $("#saveSearchButton").css("display", "inline");
                  results.removeLiquidMapDrawingToolFacet(null);
                  removeLassoPoly();
                  jDrawTool.removeClass('selected');
                  jInstructions.removeClass('active');
                  self.refreshLocationBoundaryMap();
               } else {
                  if (m_zoomErrorMessage.inRange()) {
                     track.doEvent('Hybrid Mapping', 'Tool Bar', 'Select Drawing Tool');
                     $("#saveSearchButton").css("display", "none");

                     //Disable Search Within Map when Draw Tool is selected
                     disableSearchWithinMap();

                     //m_locationBoundaryMapLayer.clearLocationBoundaryMap();    
                     jDrawTool.addClass('selected');
                     jInstructions.trigger("showTip");

                     // Hack to allow disabling the lasso tool even though the button
                     // is covered with the canvas
                     var offsetDrawTool = jDrawTool.offset(),
                        iHeight = jDrawTool.height(),
                        iWidth = jDrawTool.width(),
                        jDiv = $("<div class='bob' />").css({
                           position: 'absolute',
                           left: offsetDrawTool.left.toString() + 'px',
                           top: offsetDrawTool.top.toString() + 'px',
                           height: iHeight,
                           zIndex: 99999,
                           width: iWidth,
                           cursor: 'pointer',
                           backgroundColo: 'green'
                        });

                     jDiv.show().click(function () {
                        m_lassoTool.stop();
                        jDrawTool.removeClass("selected");
                        jInstructions.removeClass("active");
                     });
                     $(document.body).append(jDiv);

                     if (!m_lassoTool) {
                        m_lassoTool = new LassoTool("lassoTool", self);
                     }

                     m_lassoTool.start(function () {
                        jDiv.hide();
                     });
                  } else {
                     m_zoomErrorMessage.enableTemporarily('lasso');
                  }
               }
            });
         },

         /**
          * Remove all entities on the map
          */
         clearAll = function () {
            m_officeLayer.clearOffices();
            m_agentLayer.clearOffices();
            m_resultPropertyPinLayer.clearProperties();

            if (m_backgroundPropertyPinLayer) {
               m_backgroundPropertyPinLayer.clearProperties();
            }

            if (m_propertyPinAjax) {
               m_propertyPinAjax.cancel();
            }

            m_locationBoundaryMapAjax.cancel();

            resetFirstViewLoad();
            //m_locationBoundaryMapLayer.clearLocationBoundaryMap(); 
         },

         initializeZoomErrorMessage = function () {
            m_zoomErrorMessage.addTool("searchWithinMap", "Can not use the Search Within Map feature at this level");
            m_zoomErrorMessage.addTool("poi", "There are too many points of interest to show at once.");
            m_zoomErrorMessage.addTool("heatmap", "There are too many heatmap locations to show at once.");
            m_zoomErrorMessage.addTool("lasso", "Can not use draw tool at this level");
         },

         fixNavbar = function () {
            var jNavbar = $("#navbar");
            if (jNavbar.hasClass("fixed")) return;
            jNavbar.addClass("fixed");

            // Menu needs to appear over the map
            // but the tooltip boxes from map items
            // must appear over the menu
            jNavbar.find("li").on({
               'shown.bs.dropdown': function () {
                  jNavbar.addClass("showmenu");
               },

               'hidden.bs.dropdown': function () {
                  jNavbar.removeClass("showmenu");
               }
            });
         },

         m_jNav,
         m_jNavContainer,
         initCompassObj = function () {
            m_jNav = $(".NavBar_compass");
            m_jNavContainer = $(".NavBar_compassControlContainer");
         },
         refreshCompassType = function () {
            if (!m_jNav) return;
            if (m_jNav.hasClass("NavBar_compassFlat")) {
               m_jNavContainer.addClass("compassNoRotate");
            } else {
               m_jNavContainer.removeClass("compassNoRotate");
            }
         },

         initialize = function () {
            window.Ve7Infobox(m_map);

            // TODO: Add switch for sites that show background pins
            window.g_enablePropertySearchGeo = false;

            fixNavbar();

            if (window.g_enablePropertySearchGeo) {
               m_backgroundPropertyTooltipManager = new BackgroundPropertyTooltipManager(m_map);
               m_backgroundPropertyPinLayer = new BackgroundPropertyPinLayer(m_map, m_backgroundPropertyTooltipManager);
               m_propertyPinAjax = new PropertyPinAjax(m_resultPropertyPinLayer, m_backgroundPropertyPinLayer);
            }

            initializeZoomErrorMessage();
            m_pointsOfInterestFilter = new PointsOfInterestFilter(self.refreshPOI);
            initializeDrawToolInterface();
            //initializeMyPlacesToolInterface();

            m_map.layers.insert(m_lassoLayer);
            m_areaOverlayUi.setClickEvent(refreshHeatmap);

            m_mapZoomOnPageLoad = m_map.getZoom().toString();
            m_mapBoundaryOnPageLoad = m_map.getBounds();

            // Using a throttle because viewchangeend will get called lots in a short period of time
            // causing expensive ajax requests to be made!
            BingMaps.Events.addThrottledHandler(m_map, 'viewchangeend', function () {
               if (!$.contains(document.body, m_elBingMap)) return;
               m_zoomErrorMessage.refresh();
               self.refreshPOI();
               refreshHeatmap();
               self.refreshSearchWithinMap();
               self.refreshLocationBoundaryMap();
            }, 250);

            BingMaps.Events.addThrottledHandler(m_map, 'viewchange', refreshCompassType, 10);
            BingMaps.Events.addHandler(m_map, 'viewchangestart', initCompassObj);
            c21.waitFor(function () {
               return ($(".NavBar_compass").length > 0);
            }, function () {
               initCompassObj();
               refreshCompassType();
            });

            refreshHeatmap();
            self.refreshSearchWithinMap();

            m_jListContainer = $("#listContainer");

            m_mapTypeOverlay = new MapTypeOverlay(m_map);
         },

         /**
          * Attach the event that shows the hover tooltip when hovering over a card
          * @param jCard            the card the user would hover over
          * @param tooltipManager   the tooltip manager with the showHoverTooltip & hideHoverTooltip events
          * @param pinData              the pinData with the information to display to the user
          */
         attachHoverCardTooltip = function (jCard, tooltipManager, pinData, trackMessage) {
            // Prevent event from being attached multiple times
            if (jCard.attr('hoverSet') === 'y') {
               return;
            }
            jCard.attr('hoverSet', 'y');

            // Attach the event
            //var jHover = jCard.parent();
            jCard.hover(function () {
               track.doEvent('Hybrid Mapping', trackMessage);
               tooltipManager.showHoverTooltip(pinData);
            }, function () {
               tooltipManager.hideHoverTooltip();
            });
         },

         onFirstViewLoad = function () {
            /*
            console.debug("onFirstViewLoad called", {
               m_bFirstUpdate: m_bFirstUpdate,
               m_pinsFirstMapBounds: m_pinsFirstMapBounds,
               m_shapeFirstMapBounds: m_shapeFirstMapBounds
            });
            */

            if (!m_bFirstUpdate) {
               return;
            }
            if (!m_pinsFirstMapBounds) {
               return;
            }
            if (!m_shapeFirstMapBounds) {
               return;
            }

            var aLocation = m_pinsFirstMapBounds.concat(m_shapeFirstMapBounds);
            self.setViewFromLocations(aLocation);

            m_bFirstUpdate = false;
         },

         /**
          * @param aPinData       an array of objects with Latitude and Longitude properties
          */
         onUpdate = function (aPinData) {
            clearAll();
            self.refreshLocationBoundaryMap();

            if (aPinData && aPinData.length > 0) {
               var aLocation = [];
               $.each(aPinData, function (i, pinData) {
                  if(pinData.getLatitude()) {
                     var loc = pinData.getLocation();
                     if (loc && loc.latitude) {
                        aLocation.push(loc);
                     }
                  }
               });

               if (aLocation.length === 0) {
                  return;
               }

               // If we are searching within the map
               if (searchWithinMapEnabled()) {
                  self.setViewFromLocations(aLocation);
                  m_bFirstUpdate = false;
               } else if (m_bFirstUpdate) {
                  m_pinsFirstMapBounds = aLocation;
                  onFirstViewLoad();
               }
            }
         };

      function resetFirstViewLoad () {
         // Whether auto-zoom is locked (disabled)
         m_bLockAutoZoom = false;

         // Whether this is a "first" update
         m_bFirstUpdate = true;

         // The boundary shape
         // Must be set to null or fatal errors occurr
         m_shapeFirstMapBounds = null;

         // The array of pins
         // Must be set to null or fatal errors occurr
         m_pinsFirstMapBounds = null;
      }

      self.lockAutoZoomToPins = function () {
         m_bLockAutoZoom = true;
      };

      self.unlockAutoZoomToPins = function () {
         m_bLockAutoZoom = false;
      };

      /**
       * Set the map's view from an array of Location objects
       * @param {Array} aLocation  an array of Microsoft.Maps.Location objects
       * @return void
       */
      self.setViewFromLocations = function (aLocation) {
         if (m_bLockAutoZoom) {
            return;
         }
         if (searchWithinMapEnabled()) {
            return;
         }
         var bestview = BingMaps.LocationRect.fromLocations(aLocation);
         m_map.setView({
            bounds: bestview
         });
      };

      /**
       * Change the current zoom level
       * @param iDelta  delta from current zoom level
       */
      self.modifyZoom = function (iDelta) {
         var iCurrentZoom = m_map.getZoom();
         m_map.setView({
            zoom: iCurrentZoom + iDelta
         });
      };

      /**
       * Reset the map zoom
       * 
       */
      self.setMapView = function (zoomval, bestview) {
         var locRect = new BingMaps.LocationRect.fromCorners(
               new BingMaps.Location(bestview.xy, bestview.mx),
               new BingMaps.Location(bestview.my, bestview.xx)
            );

         m_map.setView({
            bounds: locRect
         });
      };

      self.getPOI = function () {
         return m_poiMapLayer;
      };

      /**
       * Generate a circle polygon
       * @param loc  Location object
       * @param radius  The radius in km
       * @param nodes  how many nodes to build the circle with
       * @param linColor  RGB value of line color (#ffffff)
       * @param linOpa  Opacity of line. Values 0 - 1.
       * @param fillColor  RGB value of fill color (#ffffff)
       * @param fillOpa  Opacity of fill. Values 0 - 1.
       * @return the generated circle polygon
       */
      self.getCircle = function (loc, radius, nodes, liColor, liWidth, liOpa, fillColor, fillOpa) {
         var R = 6371, // earth's mean radius in km 6371
            lat = (loc.latitude * Math.PI) / 180, //rad
            lon = (loc.longitude * Math.PI) / 180, //rad
            d = parseFloat(radius) / R, // d = angular distance covered on earth's surface
            locs = [],
            step = c21.parseInt(360 / nodes) || 10,
            x;

         for (x = 0; x <= 360; x += step) {
            var p2 = new BingMaps.Location(0, 0);
            var brng = x * Math.PI / 180; //rad
            p2.latitude = Math.asin(Math.sin(lat) * Math.cos(d) + Math.cos(lat) * Math.sin(d) * Math.cos(brng));
            p2.longitude = ((lon + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(lat), Math.cos(d) - Math.sin(lat) * Math.sin(p2.latitude))) * 180) / Math.PI;
            p2.latitude = (p2.latitude * 180) / Math.PI;
            locs.push(p2);
         }

         var polygonFillColor = new BingMaps.Color.fromHex(fillColor);
         polygonFillColor.a = fillOpa * 255;
         var polygonLineColor = new BingMaps.Color.fromHex(liColor);
         polygonLineColor.a = liOpa * 255;

         var polygon = new BingMaps.Polygon(locs, {
            fillColor: polygonFillColor,
            strokeColor: polygonLineColor,
            strokeThickness: liWidth
         });

         // Add the polygon to the map
         return polygon;
      };

      /**
       * Get an object that can be passed through a url
       * representing the visible bounds on the map
       * @return {Object}
       */
      self.getBounds = function () {
         var bounds = m_map.getBounds(),
            limit = {
               xy: bounds.getNorth().toString(),
               mx: bounds.getWest().toString(),
               my: bounds.getSouth().toString(),
               xx: bounds.getEast().toString(),
               zoom: m_map.getZoom()
            };

         return limit;
      };

      /**
       * Returns the zoom level of the map
       * 
       */
      self.getZoom = function () {
         return m_map.getZoom();
      };

      // TODO: Instead of iterating through hidden input data, have a script call a data holder
      // We will be transferring the same hidden information, but the result will be MUCH faster
      // (FOR PROPERTY, AGENT AND OFFICE PINS)

      /**
       * Get update map agent offices from page
       */
      self.updateOfficePins = function (jParent) {
         var aPinData = [];
         
         // For each item in the list
         (jParent || m_jListContainer).children(".recordRow").each(function () {
            var jOfficeCard = $(this),
               strOfficeId = jOfficeCard.find("input.officeId").val(),
               strLatitude = $("#officeLatitude" + strOfficeId).val(),
               strLongitude = $("#officeLongitude" + strOfficeId).val();

            var pinData = new PinData(strOfficeId, strLatitude, strLongitude, {
               card: jOfficeCard
            });

            attachHoverCardTooltip(jOfficeCard.children(".officeCard"), m_officeTooltipManager, pinData, 'Hover over an office in the search results');
            aPinData.push(pinData);
         });

         // TODO: Load office row images by ID
         lazy.load();

         onUpdate(aPinData);
         m_officeLayer.setOffices(aPinData);
      };

      /**
       * Get update map agent offices from page
       */
      self.updateAgentPins = function (jParent) {
         var aPinData = [];

         // For each item in the list
         $("#agentSearchMapHoverState").find(".agentsSearchMapOverlay").each(function () {
            var jAgentInfo = $(this),
               strLatitude = jAgentInfo.find("input.agentsOfficeLatitude").val(),
               strLongitude = jAgentInfo.find("input.agentsOfficeLongitude").val(),
               strOfficeId = jAgentInfo.find("input.officeId").val(),
               //strOfficeName = jAgentInfo.find(".officeName").text(),
               jAgentCard = (jParent || m_jListContainer).find(".agentOffice" + strOfficeId),
               jClickCard;

            var pinData = new PinData(strOfficeId, strLatitude, strLongitude, {
               card: $() // Do nothing...
            });

            attachHoverCardTooltip(jAgentCard, m_agentTooltipManager, pinData, 'Hover over an agent in the search results');
            jAgentCard.hover(function () {
               var strAgentId = $.trim($(this).parent().attr("id").substr(5)),
                  strElementSelector = "#agentClickCard" + strAgentId;

               jClickCard = $(strElementSelector).addClass("hover");
               if (jClickCard.length > 0) {
                  var jParent = jClickCard.parent(),
                     jFirst = jParent.children().first(),
                     iOffset = jFirst.offset().top,
                     iCardTop = jClickCard.offset().top,
                     iScrollTop = iCardTop - iOffset;

                  jClickCard.parent().animate({
                     scrollTop: iScrollTop
                  });
               }
               
               $(this).addClass("cardHover");
            }, function () {
               if (jClickCard) {
                  jClickCard.removeClass("hover");
               }
               $(this).removeClass("cardHover");
            });

            aPinData.push(pinData);
         });

         // TODO: Load agent row images by ID
         lazy.load();
         onUpdate(aPinData);

         m_agentLayer.setOffices(aPinData);
      };

      /**
       * Get update map properties from page
       */
      self.updatePropertyPins = function (jParent) {
         var aPinData = [];
         lazy.load();

         // For each property in the list
         $("#PropertyRowContainer").children(".recordRow").each(function () {
            var jRow = $(this),
               strLatitude = jRow.find("input[name=proplatitude]").val(),
               strLongitude = jRow.find("input[name=proplongitude]").val(),
               strShortPrice = jRow.find("input[name=shortCurrency]").val(),
               strLid = jRow.attr('id').replace(/propertyRow/, ''),
               jPropertyRecord = jRow.children(0);

            jPropertyRecord.click(function (e) {
               if (!e.isDefaultPrevented()) {
                  var strUrl = jPropertyRecord.attr("data-src");
                  if (strUrl !== undefined) {
                     cookie.set('LAST_PROPERTY_INDEX', $('.cardWrapper').index(jPropertyRecord) + 1);
                     ajax.gotoPageUrl(strUrl);
                  }
                  e.preventDefault();
               }
            });

            var propertyPin = new PinData(strLid, strLatitude, strLongitude, {
               shortPrice: strShortPrice,
               card: jRow
            });

            attachHoverCardTooltip(jRow.children(0), m_resultPropertyTooltipManager, propertyPin, 'Hover over a property in the search results');
            aPinData.push(propertyPin);
         });

         onUpdate(aPinData);
         m_resultPropertyPinLayer.setProperties(aPinData);
      };

      self.setPropertiesInView = function (aPinId) {
         //m_resultPropertyPinLayer.setPinsInView(aPinId);
      };

      self.setOfficesInView = function (aPinId) {
         //m_officeLayer.setPinsInView(aPinId);
      };

      self.setAgentsInView = function (aPinId) {
         //m_agentLayer.setPinsInView(aPinId);
      };

      /* Refresh My Places */
      self.refreshMyC21Places = function () {
         if (m_bMyPlacesEnabled) {
            //m_myPlacesMapLayer.render();
         }
      };

      self.enableMyC21Places = function () {
         enableMyPlaces();
      };

      self.disableMyC21Places = function () {
         disableMyPlaces();
      };

      self.isMyPlacesEnabled = function () {
         return isMyPlacesEnabled();
      };

      /* Clear My Places */
      self.clearMyC21Places = function () {
         //m_myPlacesMapLayer.clearMyPlaces();
      };

      /* Geocode address and get the coords */
      self.geocodeAddressAndSavePlace = function (addressLine) {
         //m_myPlacesMapLayer.geocodeAddressAndSavePlace(addressLine);
      };

      self.isSurroundingAreaViewSelected = function () {
         return false;
      };

      self.clearLocationBoundaryMap = function () {
         m_locationBoundaryMapLayer.clearLocationBoundaryMap();
      };

      self.deselectDrawingTool = function () {
         deselectDrawingTool();
      };

      self.refreshLocationBoundaryMap = function () {
         // Do not display this layer when drawing tool or search within map is selected or heat map legend is visible or surrounding area is selected.
         var strSelectedArea = m_areaOverlayUi.getAreaOverlaySelection();
         if (searchWithinMapEnabled() || strSelectedArea) {
            self.clearLocationBoundaryMap();
            return;
         }

         var bounds = self.getBounds(),
            locationlids = $("#searchLocationLIDS").val();

         if (locationlids === "") {
            m_shapeFirstMapBounds = [];
            onFirstViewLoad();
         } else {
            m_locationBoundaryMapAjax.getData(bounds, locationlids, {
               success: function (aLocation) {
                  m_shapeFirstMapBounds = aLocation;
                  onFirstViewLoad();
               }
            });
         }
      };

      /** BEGIN SCHOOL METHODS **/
      self.clearLocationBoundaryMap = function () {
         m_locationBoundaryMapLayer.clearLocationBoundaryMap();
      };

      self.setSchoolRadius = function (iRadiusKm) {
         m_schoolPinLayer.setSchoolRadius(iRadiusKm);
      };

      self.setInitialSelectedSchools = function (aSchoolSearchItem) {
         m_schoolPinLayer.setInitialSelectedSchools(aSchoolSearchItem);
      };

      self.setSelectedSchools = function (aSelectedSchools) {
         m_schoolPinLayer.setSelectedSchools(aSelectedSchools);
      };

      self.showUnselectedSchools = function () {
         m_schoolPinLayer.showUnselectedSchools();
      };

      self.hideUnselectedSchools = function () {
         m_schoolPinLayer.hideUnselectedSchools();
      };

      self.setSchools = function (aSchoolSearchItem) {
         m_schoolPinLayer.setSchools(aSchoolSearchItem);
         self.updateSchoolHoverState();
      };

      self.clearSchools = function () {
         m_schoolPinLayer.clearSchools();
      };

      self.setSchoolsInView = function (aPinId) {
         m_schoolPinLayer.setSchoolsInView(aPinId);
      };

      self.updateSchoolHoverState = function () {
         $("#schoolSearchResults").find(".schoolRecord").each(function () {
            var jRecord = $(this),
               jClickable = jRecord.find(".clickForSchoolDetails"),
               jSchoolDetailsLink = jRecord.find(".viewSchoolDetailsLink"),
               strId = jRecord.find("input.schoolID").val(),
               pinData = m_schoolPinLayer.getPinData(strId);

            if (jRecord.attr('hoverSet') !== 'y') {
               jSchoolDetailsLink.click(function () {
                  m_schoolTooltipManager.showClickTooltip(pinData);
               });

               jClickable.click(function () {
                  jSchoolDetailsLink.click();
               });
            }

            // bug with infinite scroll
            attachHoverCardTooltip(jRecord, m_schoolTooltipManager, pinData, 'Hover over a school');
         });
      };
      /** END SCHOOL METHODS **/

      self.refreshSearchWithinMap = function () {
         // If searching by map
         if (searchWithinMapEnabled()) {
            // The paginator paramter should not be removed on page load. The below logic identifies if its a Map Pan vs Original Map bounds on page load 
            if (m_mapZoomOnPageLoad === m_map.getZoom().toString() && m_mapBoundaryOnPageLoad.toString() === m_map.getBounds().toString()) { //Called on entire results page load
               // Get properties in map range
               results.changeLiquidMapSearchWithinMapFacet(true);
               m_zoomErrorMessage.disable('searchWithinMap');
               return;
            }
            if (!m_zoomErrorMessage.inRange()) {
               self.refreshLocationBoundaryMap();
            }
            if (m_zoomErrorMessage.inRange()) {
               // Get properties in map range
               results.changeLiquidMapSearchWithinMapFacet();
               m_zoomErrorMessage.disable('searchWithinMap');
            } else {
               // Remove search within map
               results.removeLiquidMapSearchWithinMapFacet();
               m_zoomErrorMessage.enable('searchWithinMap');
            }
            self.refreshLocationBoundaryMap();
         } else {
            m_zoomErrorMessage.disable('searchWithinMap');
         }
      };

      /**
       * Remove all entities on the map
       */
      self.clearTooltips = function () {
         if (m_backgroundPropertyTooltipManager) {
            m_backgroundPropertyTooltipManager.clear();
         }

         m_resultPropertyTooltipManager.clear();
         m_officeTooltipManager.clear();
         m_agentTooltipManager.clear();
         m_myPlaceTooltipManager.clear();
         m_surroundingAreaTooltipManager.clear();
      };

      self.clearHeatMap = function () {
         m_heatMapLayer.clearHeatMap();
      };

      self.refreshHeatmap = function () {
         refreshHeatmap();
      };

      self.clearPOI = function () {
         m_poiMapLayer.clearPOI();
      };

      self.refreshPOI = function () {
         var sTypes = m_pointsOfInterestFilter.getTypes();

         if (sTypes.length > 0) {
            if (m_zoomErrorMessage.inRange()) {
               m_poiMapLayer.render(sTypes);
               m_pointsOfInterestFilter.setHash(sTypes);
            } else {
               m_zoomErrorMessage.enable('poi');
            }
         } else {
            m_zoomErrorMessage.disable('poi');
            m_poiMapLayer.render(sTypes);
            m_pointsOfInterestFilter.setHash(sTypes);
         }
      };

      /**
       * Add an array of locations
       * @param poly  an array of Microsoft.Maps.Location
       */
      self.addLassoPoly = function (aLocation) {
         var poly = new BingMaps.Polyline(aLocation, {
            fillColor: new BingMaps.Color(0, 0, 0, 0),
            strokeColor: new BingMaps.Color(255, 0, 0, 255)
         });

         $("#drawTool").addClass("selected");

         // Add the shape to the map
         removeLassoPoly();
         m_lassoLayer.add(poly);
         m_lassoPoly = poly;
      };

      /**
       * Add an array of points (excluding the redundant LAST point)
       * @param poly  an array of Microsoft.Maps.Point
       */
      self.addLassoPolyByPixels = function (aPointPath) {
         var aLocation = m_map.tryPixelToLocation(aPointPath, BingMaps.PixelReference.control);
         m_aLocationForUrl = [];

         // NOTE: Server requires lon, lat instead of lat, lon
         $.each(aLocation, function (i, loc) {
            m_aLocationForUrl.push(loc.longitude);
            m_aLocationForUrl.push(loc.latitude);
         });

         aLocation.push(aLocation[0]);

         self.addLassoPoly(aLocation);

         results.changeLiquidMapDrawingToolFacet(null, m_aLocationForUrl);
      };

      self.fixAfterShow = function () {
         // FIXME: This is a hack to get the map tiles to refresh
         // (the map does not show tiles after being revealed, if initially hidden)
         var iZoom = m_map.getZoom();
         m_map.setView({
            zoom: iZoom + 1
         });

         setTimeout(function () {
            m_map.setView({
               zoom: iZoom
            });
         }, 1000);
      };

      self.initSurroundingAreas = function (surroundingAreasMapping) {
         m_surroundingAreaMapLayer = new SurroundingAreaMapLayer(self, m_map, m_surroundingAreaTooltipManager, surroundingAreasMapping);
      };

      self.refreshSurroundingAreaPin = function(strId) {
         m_surroundingAreaMapLayer.refreshPin(strId);
      };

      /* Render Surrounding Area */
      self.renderSurroundingAreas = function() {
         m_surroundingAreaMapLayer.render();
      };

      /* Set a surrounding area checked state */
      self.setSurroundingAreaChecked = function(id, bChecked) {
         m_surroundingAreaMapLayer.setChecked(id, bChecked);
      };
      
      /* Set a surrounding area hover state */
      self.setSurroundingAreaHover = function(id, bHover) {
         m_surroundingAreaMapLayer.setHover(id, bHover);
      };
      
      /* Clear Surrounding Areas */
      self.clearSurroundingAreas = function() {
         m_surroundingAreaMapLayer.clearSurroundingAreas();
      };

      self.clearAll = clearAll;

      initialize();
   };
});
